module.exports = __webpack_public_path__ + "img/Chart-app.e834f826.jpg";